import { FC } from "react";

import { Badge, Card } from "react-bootstrap";
import { useParams } from "react-router-dom";

import { DateTime } from "luxon";

import { getAppointmentStatusValuesBySlug } from "@/_constants/appointment";
import { getServiceOrderTypeValuesByType } from "@/_constants/serviceOrder";
import Loader from "@/common/components/Loader";
import { StatusTag } from "@/modules/order/components/OrderInvoiceInfosPreview/components/StatusTag";
import { useGetServiceById } from "@/modules/order/hooks/service.hooks";


const CurrentOrderCard: FC = () => {
  const { id: serviceId } = useParams<{ id: string }>();
  const { data: service, isLoading } = useGetServiceById(serviceId!);

  if (isLoading) {
    return (
      <Card className="border-0 shadow-sm bg-white">
        <Card.Body className="text-center py-8">
          <Loader />
        </Card.Body>
      </Card>
    );
  }

  if (!service) {
    return (
      <Card className="border-0 shadow-sm bg-white">
        <Card.Body>
          <div className="text-center text-gray-500">
            Aucune donnée de commande disponible
          </div>
        </Card.Body>
      </Card>
    );
  }

  const serviceTypeInfo = getServiceOrderTypeValuesByType(
    service.type as keyof object
  );
  const statusInfo = getAppointmentStatusValuesBySlug(
    service.appointment.lastStatus.status.slug
  );

  const formattedCreationDate = service.createdAt
    ? DateTime.fromISO(service.createdAt).toFormat("d LLLL yyyy", {
        locale: "fr",
      })
    : "-";

  const getStatusClassName = (statusSlug: string) => {
    switch (statusSlug) {
      case "PLANNING":
        return "bg-blue-100 text-blue-700";
      case "WAITING_TENANT":
        return "bg-yellow-100 text-yellow-700";
      case "PLANNED":
        return "bg-green-100 text-green-700";
      case "CONFIRMED":
        return "bg-purple-100 text-purple-700";
      case "DONE":
        return "bg-gray-100 text-gray-700";
      case "FINALIZED":
        return "bg-green-100 text-green-700";
      case "CANCEL":
        return "bg-red-100 text-red-700";
      default:
        return "bg-orange-100 text-orange-700";
    }
  };

  return (
    <Card className="border-0 shadow-sm bg-white">
      <Card.Body>
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-600">Référence:</span>
            <Badge className="bg-purple-100 text-purple-700">
              {service.datedReference || service.id}
            </Badge>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-600">Type:</span>
            <Badge className="bg-gray-100">
              {serviceTypeInfo?.labelMin || service.type}
            </Badge>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-600">Date de création:</span>
            <span className="text-sm font-medium">{formattedCreationDate}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-600">Statut:</span>
            <StatusTag
              text={
                statusInfo?.name || service.appointment.lastStatus.status.slug
              }
              className={getStatusClassName(
                service.appointment.lastStatus.status.slug
              )}
            />
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default CurrentOrderCard;
